import { Palette } from '../constants/palette';
export const pillControl = {
    selectorColors: {
        disabledColor: Palette.gray50,
        hoverBackground: Palette.gray90,
        focusBorderColor: Palette.goGreen,
    },
    baseColors: {
        bg: Palette.gray96,
        borderColor: Palette.gray96,
        color: Palette.darkBlue,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGlsbC1jb250cm9sLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL3BpbGwtY29udHJvbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFFL0MsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUF5QjtJQUMvQyxjQUFjLEVBQUU7UUFDZCxhQUFhLEVBQUUsT0FBTyxDQUFDLE1BQU07UUFDN0IsZUFBZSxFQUFFLE9BQU8sQ0FBQyxNQUFNO1FBQy9CLGdCQUFnQixFQUFFLE9BQU8sQ0FBQyxPQUFPO0tBQ2xDO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsRUFBRSxFQUFFLE9BQU8sQ0FBQyxNQUFNO1FBQ2xCLFdBQVcsRUFBRSxPQUFPLENBQUMsTUFBTTtRQUMzQixLQUFLLEVBQUUsT0FBTyxDQUFDLFFBQVE7S0FDeEI7Q0FDRixDQUFDIn0=